<template>
	<b-container class="show-document" style="width:1200px">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark">
					<i class="fa fa-chevron-left"></i>
					{{ $t('back') }}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					v-if="items.documentStatus === 'SUSPENDED'"
					@click="saveAndFinish('READY')"
					variant="btn btn-success"
				>
					<i class="fa fa-save"></i> &nbsp;
					<span>{{ $t('warehouse.document.saveAndFinish') }}</span>
				</b-button>
				<b-button
					v-else
					variant="outline-dark"
					@click="print"
					class="ml-3"
				>
					<i class="fa fa-print"></i>
					{{ $t('pricing.print') }}
				</b-button>
			</div>
			<div class="clearfix"/>
		</div>
		<div class="doc-body">
			<b-card class="p-3" style="min-height:29.7cm; min-width:21cm !important;">
				<b-row>
					<b-col>

						<b class="mr-3"><ins>{{ items.fromDepartmentName }}</ins></b><br>
						<span class="mr-2">
							<b>№</b> {{ items.regNumber }}
						</span>
						<span>
							<b>{{ $t('pending.regDate') }}: </b> {{ items.regDate }}
						</span><br>
						<span>{{ $t('priceAkt.commission') }}:</span>
					</b-col>
					<b-col align="center">
						<h5>{{ items.documentType == 'PROTOKOL' ? 'Акт' : 'Акт на экспертизу' }} списания</h5>
					</b-col>
					<b-col align="center">
						<b>"Утверждаю"</b><br>
						<p>Генеральный директор</p><br>
						_____________________________________<br>
						______________
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<span><b>Основание для списания: </b></span>
						<span>{{ items.reason }}</span>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col>
						<b-table :items="items.whItems" :fields="columns" :busy="loading" hover striped bordered>
							<template #table-busy>
								<div class="text-center text-primary my-3">
									<b-spinner class="align-middle"/>
									<strong class="h4">Loading...</strong>
								</div>
							</template>
							<template slot="thead-top" slot-scope="props">
								<tr>
									<th colspan="6"/>
									<th colspan="2" class="text-center">{{ $t('incomes.create.price') }}</th>
									<th colspan="2" class="text-center">{{ $t('pos.sum') }}</th>
								</tr>
							</template>
							<template slot="id" slot-scope="data">
								{{ data.index+1 }}
							</template>
							<template slot="multiBarcode" slot-scope="data">
								<h6>
									<b-badge v-for="barcode in data.item.multiBarcodesString" class="ml-2">{{ barcode }}</b-badge>
								</h6>
							</template>
							<template slot="incomingPriceUzs" slot-scope="data">
								{{ data.item.incomingPriceUzs | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}
							</template>
							<template slot="priceUzs" slot-scope="data">
								{{ data.item.priceUzs | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}
							</template>
							<template slot="sumIncome" slot-scope="data">
								{{ data.item.count * data.item.incomingPriceUzs | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}
							</template>
							<template slot="sumPrice" slot-scope="data">
								{{ data.item.count * data.item.priceUzs | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}
							</template>
							<template slot="bottom-row" slot-scope="data">
								<td v-for="(field, i) in data.fields" class="text-center">
									<b v-if="field.key === 'termOfItem'">Итого:</b>
									<b v-if="field.key === 'count'">{{ sumCount }}</b>
									<b v-if="field.key === 'sumIncome'">{{ sumIncome | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}</b>
									<b v-if="field.key === 'sumPrice'">{{ sumPrice | currency({ symbol: currencyDep, fractionCount: 4, symbolPosition: 'back', thousandsSeparator: ' ' }) }}</b>
								</td>
							</template>
						</b-table>
					</b-col>
				</b-row>
				<b-row class="mt-5">
					<b-col>
						<b>Товаровед:__________________________________________________</b>
					</b-col>
					<b-col>
						<b>Проверил:__________________________________________________</b>
					</b-col>
				</b-row>
				<b-row class="mt-5">
					<b-col>
						<b>{{ $t('priceAkt.signature') }}:</b>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b>1.________________________________________</b>
					</b-col>
					<b-col>
						<b>2.________________________________________</b>
					</b-col>
					<b-col>
						<b>3.________________________________________</b>
					</b-col>
				</b-row>
				<b-row class="mt-4 mb-5">
					<b-col>
						<b>4.________________________________________</b>
					</b-col>
					<b-col>
						<b>5.________________________________________</b>
					</b-col>
					<b-col>
						<b>6.________________________________________</b>
					</b-col>
				</b-row>
				<b-row class="mt-5 mb-5">
					<b-col>
						<b>Ознакомлен(а):__________________________________________________</b>
					</b-col>
				</b-row>
			</b-card>
		</div>
	</b-container>
</template>

<script>
import WhDocument from "../../../../services/wh-document.service";

export default {
	name: "writeOffNakladnoy",
	data() {
		return {
			items: {},
			columns: [
				{ key: 'id', label: '№', visible: true, class: 'text-center' },
				{ key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center' },
				{ key: 'itemName', label: this.$t('incomes.create.product'), visible: true },
				{ key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center' },
				{ key: 'regNumber', label: this.$t('pricing.costNumber'), class: 'text-center' },
				{ key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center' },
				{ key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center' },
				{ key: 'incomingPriceUzs', label: this.$t('prices.item.sum'), class: 'text-center' },
				{ key: 'priceUzs', label: 'Цена (прод)', class: 'text-center' },
				{ key: 'sumIncome', label: 'Сумма (приход)', class: 'text-center' },
				{ key: 'sumPrice', label: 'Сумма (прод)', class: 'text-center' }
			],
			loading: false
		}
	},
	computed: {
		currencyDep() {
			return this.items.fromDepCurrencyName
		},
		sumCount() {
			let sum = 0
			this.items.whItems.forEach(item => {
				sum+=item.count
			})
			return sum
		},
		sumIncome() {
			let sum = 0
			this.items.whItems.forEach(item => {
				sum+=item.count * item.incomingPriceUzs
			})
			return sum
		},
		sumPrice() {
			let sum = 0
			this.items.whItems.forEach(item => {
				sum+=item.count * item.priceUzs
			})
			return sum
		}
	},
	watch: {},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		saveAndFinish(status) {
			this.items.documentStatus = status
			WhDocument.saveDocWriteOff(this.items).then(res => {
				this.$router.push(`/warehouse-management/write-offs`)
			})
		}
	},
	created() {
		WhDocument.get(this.$route.params.id).then(res => {
			this.items = res.data
		})
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
}

@page  {
	margin: 1cm;
}
</style>
